export const activeRequests = {};

export const addActiveRequest = (key, value) => {
    activeRequests[key] = value;
};

export const deleteActiveRequest = key => {
    delete activeRequests[key];
};

export const useLatestRequest = async (requestKey, callback) => {
    const timestamp = new Date().getTime();
    deleteActiveRequest(requestKey);
    addActiveRequest(requestKey, timestamp);

    const response = await callback();

    const activeRequestTimestamp = activeRequests[requestKey];

    if (timestamp !== activeRequestTimestamp) return;

    return response;
};
